export const sizes = {
  small: 376, // iPhone 6, 6S, 7 and 8, X
  medium: 390, // 12 Pro
  large: 414, // iPhone 6+, 7+ and 8+
}

export const isDeviceSmall = window.innerWidth <= sizes.small
